<script>
    import {onMount} from 'svelte'; 
    import { on } from 'svelte/events'
    let _ui = ui;
    let colorMode = _ui("mode");
 
    const mode = async () => {
       colorMode = _ui("mode") == "dark" ? "light" : "dark";
       localStorage.setItem('colorMode', colorMode)
       await _ui("mode", colorMode);
    }

    onMount(async () => {
        if (localStorage.getItem('colorMode') != null) {
            colorMode = localStorage.getItem('colorMode')
        }
    })
</script>

<button on:click={() =>mode()} class="transparent circle"><i>{colorMode != "dark" ? "dark_mode" : "light_mode"}</i></button>
